import { HTTP } from '../../utils'

export const populateEvent = (uuid) => {
  return HTTP().get('/event/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const saveEvent = (eventObj) => {
  return HTTP().put('/event/' + eventObj.uuid, eventObj)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}

export const saveNewEvent = (eventObj) => {
  console.log('in save new event...')
  console.log('eventObj: ' + eventObj)
  return HTTP().put('/event?parentSpaceId=' + eventObj.owningLibraryId, eventObj)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}

export const doCsvUploadForEvent = (institutionId, createdByUuid, folderId, fileData) => {
  if (!institutionId || !createdByUuid || !folderId || !fileData) {
    return
  }
  let url = '/event/csvupload?createdByUuid=' + createdByUuid + '&folderId=' + folderId + '&institutionId=' + institutionId
  return HTTP().post(url, fileData)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}



// WEBPACK FOOTER //
// ./src/app/event/api.js